import { Result } from "@webiny/feature/api";
import { createImplementation } from "@webiny/feature/api";
import { MoveEntryRepository as RepositoryAbstraction } from "./abstractions.js";
import { StorageOperations } from "~/features/shared/abstractions.js";
import type { CmsModel } from "~/types/index.js";
import { EntryPersistenceError } from "~/domain/contentEntry/errors.js";
import { RuntimeTenant } from "~/features/runtimeTenant/abstractions.js";

/**
 * MoveEntryRepository - Handles storage operations for moving entries.
 *
 * Responsibilities:
 * - Call storage operation to move entry to different folder
 * - Handle storage errors
 */
class MoveEntryRepositoryImpl implements RepositoryAbstraction.Interface {
    public constructor(
        private storageOperations: StorageOperations.Interface,
        private runtimeTenant: RuntimeTenant.Interface
    ) {}

    async execute(
        initialModel: CmsModel,
        id: string,
        folderId: string
    ): Promise<Result<void, RepositoryAbstraction.Error>> {
        const model = this.runtimeTenant.assign(initialModel);

        try {
            await this.storageOperations.entries.move(model, id, folderId);
            return Result.ok();
        } catch (error) {
            return Result.fail(new EntryPersistenceError(error as Error));
        }
    }
}

export const MoveEntryRepository = createImplementation({
    abstraction: RepositoryAbstraction,
    implementation: MoveEntryRepositoryImpl,
    dependencies: [StorageOperations, RuntimeTenant]
});
